import api from '@shared/services/api.js';

export async function getLockDeskLoans() {
  return api.get('/pe/api/lock-desk/loans');
}

export async function getLockDeskLoan(loanId) {
  // The pipeline's expanding search forwards raw search text. Loan numbers in
  // production do contain spaces, which a path segment mangles, and `%`, which
  // starts a percent-escape and can be rejected as a malformed URL before routing.
  return api.get(`/pe/api/lock-desk/loans/${encodeURIComponent(loanId)}`);
}

export async function getActionRequiredCount() {
  return api.get('/pe/api/lock-desk/loans/action-required/count/');
}

export async function getActionRequiredSummary() {
  return api.get('/pe/api/lock-desk/loans/action-required/summary');
}

//TODO point this function to the correct endpoint.
export async function getActionRequiredLoans(options) {
  const url = api.constructUrl(
    '/pe/api/lock-desk/loans/action-required/',
    options,
  );
  return api.get(url);
}

/** Returns list of loan resource locks
 *
 *  @param {String} loanId los loan id.
 *
 *  @returns {Object} The result.
 */
export async function getIsLoanResourceLockedExternally(loanId) {
  return api.get(`/pe/api/loans/${loanId}/is-resource-locked-externally/`);
}

/** Returns dict of loans disconnected from pipeline monitoring */
export async function getDisconnectedPipelineMonitoringLoans() {
  const url = api.constructUrl(
    `/pe/api/pipeline-monitoring/disconnected-loans`,
  );
  return api.get(url);
}
/** Disable pipeline monitoring for selected loans
 *
 *  @param {Array} loanIds los loan ids.
 *
 *  @param {Array} loanNumbers los loan Numbers.
 */
export async function disconnectPipelineMonitoringLoans(loanIds, loanNumbers) {
  const url = api.constructUrl(
    `/pe/api/pipeline-monitoring/disconnected-loans`,
  );
  return api.post(url, {
    mode: 'add',
    loan_ids: loanIds,
    loan_numbers: loanNumbers,
  });
}

/** Returns actions allowed for a loan
 *
 *  @param {String} loanId los loan id.
 *  @param {String | null} [productId] PE3 id of the product being selected/changed. When
 *    provided, the backend evaluates that product's custom policy pre-lock instead
 *    of falling back to the org default policy.
 *  @param {String | null} [audienceId] audience (channel) id for the selection.
 *
 *  @returns {Promise<Object>} The result containing access levels and disallow reasons for each action.
 */
export async function getActionsAllowed(
  loanId,
  productId = null,
  audienceId = null,
) {
  const baseUrl = `/pe/api/loans/${loanId}/actions-allowed`;
  const url =
    productId || audienceId
      ? api.constructUrl(baseUrl, { productId, audienceId })
      : baseUrl;
  return api.get(url);
}
